import React, { useEffect, useState } from "react";
import Card from "../../../../../common/element/Card";
import BtnPrimary from "../../../../../common/element/Buttons/btnPrimary";
import Dialog from "../../../../../common/element/Dialog";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useDispatch ,useSelector} from "react-redux";
import ThreeDotLoaderBlue from "../../../../../common/element/ButtonLoader/ThreeDotLoaderBlue";
import { GetWokerSeatPayment } from "../../../../../actions/admin-worker/GetWokerSeatPayment";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
// import { InviteWorker } from "../../../../../../../actions/provider-portal/worker/InviteWorker";
import { InviteWorker } from "../../../../../actions/admin-worker/InviteWorker";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
import { GetInvoicePdfById } from "../../../../../actions/admin-provider/worker/GetInvoicePdfById";
import ThreeDotLoader from "../../../../../common/element/ButtonLoader/ThreeDotLoader";
const PaymentMethod = ({
  newSeat,
  provider_type_id,
  openUnsaveDialog,
  updateObject,
  subscriptionStatus,
  personName,
  organisation_id,
}) => {
  const orgId = "";
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const [dialogInvoice, setDialogInvoice] = useState(false);
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const [dialogIsOpen, setIsOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);
  const [agree, setAgree] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [workerFees, setWorkerFees] = useState("");
  const [savedCard, setSavedCard] = useState(null);
  const [useSavedCard, setUseSavedCard] = useState(false)
  const [cardExpiredOrNot, setCardExpiredOrNot] = useState(false);
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));

  const handleSubmit = async (event) => {
    event.preventDefault();
    // setIsProcessing(true);



    if (cardExpiredOrNot) {

    } else {
      if (!useSavedCard) {
        setIsProcessing(true);
        if (!stripe || !elements) {
          return;
        }
        const cardElement = elements.getElement(CardElement);
        const { error, token } = await stripe.createToken(cardElement);

        if (error) {
          setIsProcessing(false);
          setError(error.message);
          console.error(error);
        } else {
          const payload = {
            ...updateObject,
            buyNewSeatsCount: newSeat,
            payment_info: JSON.stringify({ ...workerFees, cardToken: token.id }),
            provider_type_id: provider_type_id,
            // is_licence_paid_by_provider: isProvLicencePaid,
            subscriptionStatus: workerFees?.subscriptionStatus ? workerFees?.subscriptionStatus : "",
          };
          dispatch(InviteWorker(payload,ipAddress))
            .then((response) => {
              if (response.success) {
                dispatch(
                  GetInvoicePdfById({
                    sub_invoice_id: response?.data?.sub_invoice_id,
                  })
                ).then((responsedata) => {
                  if (responsedata.success) {
                    setInvoiceData(responsedata?.data);
                    setDialogInvoice(true);
                    setIsProcessing(false);
                  } else {
                    setIsProcessing(false);
                  }
                }).finally(() => {
                  setIsProcessing(false);
                })

                // localStorage.setItem("workerInviteData", "");
                // setAddOpen(true);
                // setIsOpen(false);
                // setinviteData([]);
                // setrefetch(!refetch);
              }
              if (response.status == 409) {
                // notify.show(response.message, "error");
                setIsProcessing(false);
              } else if (response.status === 401) {
                setIsProcessing(false);
                handleUnauthorizedAccess();
              }
            })
            .catch((error) => {
              setIsProcessing(false);
            });
        }
      }

      if (useSavedCard) {
        setIsProcessing(true);
        const payload = {
          ...updateObject,
          buyNewSeatsCount: newSeat,
          payment_info: JSON.stringify({
            prorateFees: workerFees?.prorateFees,
            provider_type_id: workerFees?.provider_type_id

          }),
          subscriptionStatus: workerFees?.subscriptionStatus ? workerFees?.subscriptionStatus : "",
          provider_type_id: provider_type_id,
          // is_licence_paid_by_provider: isProvLicencePaid,
        };
        dispatch(InviteWorker(payload,ipAddress))
          .then((response) => {
            if (response.success) {
              dispatch(
                GetInvoicePdfById({
                  sub_invoice_id: response?.data?.sub_invoice_id,
                })
              ).then((responsedata) => {
                if (responsedata.success) {
                  // setAgree(true);
                  setInvoiceData(responsedata?.data);
                  setDialogInvoice(true);
                  setIsProcessing(false);
                } else {
                  setIsProcessing(false);
                }
              }).finally(() => {
                setIsProcessing(false);
              })

              // localStorage.setItem("workerInviteData", "");
              // setAddOpen(true);
              // setIsOpen(false);
              // setinviteData([]);
              // setrefetch(!refetch);
            }
            if (response.status == 409) {
              // notify.show(response.message, "error");
              setAgree(true);
            } else if (response.status === 401) {
              setAgree(true);
              handleUnauthorizedAccess();
            }
          })
          .catch((error) => {
            setAgree(true);
            setIsProcessing(false);
          });
      }
    }



  };

  useEffect(() => {
    let payload = {
      provider_org_id: organisation_id,
      newSeatCount: newSeat,
      provider_type_id: provider_type_id,
    };
    dispatch(GetWokerSeatPayment(payload)).then((response) => {
      if (response.success) {
        setWorkerFees(response.data);
        // workerFees,
      }
    });
  }, []);

  useEffect(() => {
    if (workerFees?.cardData?.[0]) {
      setUseSavedCard(true);
      setSavedCard(workerFees?.cardData?.[0]);

      if (workerFees?.cardData?.[0]) {
        const checkCardExpiry = workerFees?.cardData?.[0];
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-based month
        const currentYear = currentDate.getFullYear();

        if (
          checkCardExpiry.exp_year < currentYear ||
          (checkCardExpiry.exp_year === currentYear && checkCardExpiry.exp_month < currentMonth)
        ) {
          setCardExpiredOrNot(true);

        }
        else {
          setCardExpiredOrNot(false);

        }
      }
    }

  }, [workerFees])
  const onCloseInvoice = () => {
    openUnsaveDialog();
    setDialogInvoice(false);
  };

  const downloadInvoice = () => {
    // invoiceData.xero_invoice_pdf
    if (invoiceData && invoiceData.xero_invoice_pdf) {
      const link = document.createElement("a");
      link.href = invoiceData.xero_invoice_pdf;
      link.download = "invoice.pdf"; // Set the file name
      link.target = "_blank"; // Open in new tab for security if on another domain
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  return (
    <div className="pl-6 pr-6">
      <h5 className="text-blue-800 font-semibold text-2xl mb-2">
        Payment options
      </h5>
      <p className="text-gray-700 mb-3">
        This annual payment covers a license for one client and two included workers
      </p>
      <div>
        <div className="w-full">
          <form>
            <Card className="p-7 border border-gray-200 rounded-xl">
              <h4 className="font-bold text-gray-700 text-base mb-1">Seats</h4>
              <p className="text-gray-700 mb-7">
                {newSeat} additional Worker(s)
              </p>
              <h4 className="font-bold text-gray-700 text-base mb-1">
                Annual Fee (ex GST)
              </h4>
              <p
                className={`flex gap-2 ${workerFees?.price || workerFees?.prorateFees
                  ? "text-gray-700"
                  : "text-red-500"
                  }`}
              >
                {workerFees?.price || workerFees?.prorateFees
                  ? `$ ${(Number(workerFees.price || workerFees.prorateFees) * newSeat).toFixed(2)}`
                  : "We couldn’t retrieve the fee information. Please try again later."}
              </p>
            </Card>
            {/* <Card className="p-7 border border-gray-200 rounded-xl mt-7">
              <h4 className="font-bold text-gray-700 text-base mb-5">
                Select a payment method
              </h4>
              <div className="inline-flex rounded-md mb-7 validation-filter">
                <Segment className="payment-btn" onClick={preventDefault}>
                  <Segment.Item value="Stripe">
                    <span
                      onClick={() => {
                        handleSubmit("stripe");
                        // setDocAdd(true);
                        setPaypalMethod(false);
                      }}
                    >
                      <img src="/assets/icons-svg/stripe.svg" alt="" /> Stripe
                    </span>
                  </Segment.Item>
                </Segment>
              </div>
            </Card> */}
            <div>
              <div className="w-full">
                <form>
                  <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                    <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                      Payment options
                    </h5>
                    <div className="bg-gray-100">
                      <div className="bg-white w-full">
                        {/* Payment Method Buttons */}
                        <h2 className="text-lg font-semibold mb-3">
                          Card Information
                        </h2>
                        <form className="space-y-4">
                          {/* Card Number */}
                          <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                            {useSavedCard && savedCard && (
                              <>
                                <div
                                  className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition hover:shadow-md ${useSavedCard ? "border-blue-500" : "border-gray-300"
                                    }`}
                                  onClick={() => setUseSavedCard(true)}
                                >
                                  <label className="flex items-center gap-4 w-full cursor-pointer">
                                    <input
                                      type="radio"
                                      name="paymentMethod"
                                      checked={useSavedCard}
                                      onChange={() => setUseSavedCard(true)}
                                      className="form-radio text-blue-600 cursor-pointer"
                                    />
                                    <div className="flex justify-between items-center w-full text-sm text-gray-800">
                                      <span className="tracking-widest font-mono text-base">
                                        **** **** **** {savedCard.last4}
                                      </span>
                                      <div className="flex items-center gap-4 text-gray-500 text-sm ml-4">
                                        <span className="capitalize">{savedCard.brand}</span>
                                        <span>
                                          {String(savedCard.exp_month).padStart(2, '0')}/{savedCard.exp_year}
                                        </span>
                                      </div>
                                    </div>
                                  </label>

                                </div>
                                {cardExpiredOrNot && (
                                  <div className="text-red-500 text-sm mt-1 ">
                                    {"We're sorry, but your credit card has expired and we couldn't process your payment."}
                                  </div>
                                )}
                              </>
                            )}
                            {!useSavedCard && (<CardElement
                              options={{
                                hidePostalCode: true,
                                disableAutofill: true, // Prevent autofill suggestions
                                style: {
                                  base: {
                                    fontSize: "16px",
                                    color: "#333",
                                    "::placeholder": {
                                      color: "#a0aec0",
                                    },
                                  },
                                  invalid: { color: "#e53e3e" },
                                },
                              }}
                            />)}
                          </div>

                          {/* Checkbox */}
                          <div className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              id="terms"
                              checked={agree}
                              onChange={() => setAgree(!agree)}
                              className="cursor-pointer"
                            />
                            <label
                              htmlFor="terms"
                              className="text-sm text-gray-600 cursor-pointer"
                            >
                              I understand and accept that this licensing fee is valid for 12 months
                            </label>
                          </div>

                          {/* Submit Button */}

                          {/* Error Message */}
                          {error && (
                            <p className="text-red-500 text-sm">{error}</p>
                          )}
                          <div className="flex mt-7 step2-btn-block form-footer justify-between">
                            <BtnLight
                              className="w-auto px-6 mr-2 flex justify-center items-center pre-step"
                              onClick={openUnsaveDialog}
                            >
                              <button className=" px-6  flex justify-center items-center next-step">
                                <img
                                  src="assets/icons-svg/arrow-left.svg"
                                  alt=""
                                  className="mr-2"
                                />{" "}
                                Cancel
                              </button>
                            </BtnLight>
                            <BtnPrimary
                              disabled={
                                 !agree ||
                                 isProcessing || cardExpiredOrNot || 
                                (!workerFees?.prorateFees && !workerFees?.price)}
                              className="w-auto px-6"
                              onClick={handleSubmit}
                            >
                              {isProcessing ? (
                                <ThreeDotLoader />
                              ) : (
                                "Confirm and pay"
                              )}
                            </BtnPrimary>
                          </div>
                          {/* <div className="flex justify-center mt-6 show-on-mobile">
                                        <Link
                                          to="/login"
                                          className="text-xs text-gray-600 font-semibold hover:text-gray-900 focus:text-gray-600 flex  items-center"
                                        >
                                          Back to log in
                                        </Link>
                                      </div> */}
                        </form>
                      </div>
                    </div>
                  </Card>
                </form>
              </div>
            </div>
          </form>
        </div>
        {/* Invoice code */}
        <Dialog
          isOpen={dialogInvoice}
          onClose={onCloseInvoice}
          onRequestClose={onCloseInvoice}
          bodyOpenClassName="overflow-hidden"
          width={720}
        >
          <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
            <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12450_78578)">
                  <path
                    d="M19.1658 20.8745C19.9709 20.8745 20.6214 20.2225 20.6214 19.4191V15.5467C20.6214 14.7434 19.9709 14.0914 19.1658 14.0914H13.3557C12.5506 14.0914 11.9 14.7434 11.9 15.5467V19.4191C11.9 20.2225 12.5506 20.8745 13.3557 20.8745H19.1658ZM19.1658 19.5128H13.3557C13.304 19.5128 13.262 19.4707 13.262 19.4191V15.5467C13.262 15.4951 13.304 15.4531 13.3557 15.4531H19.1658C19.2174 15.4531 19.2594 15.4951 19.2594 15.5467V19.4191C19.2594 19.4707 19.2174 19.5128 19.1658 19.5128Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M19.2593 15.5458C19.2593 16.0251 18.8703 16.4141 18.391 16.4141H14.1303C13.651 16.4141 13.262 16.0251 13.262 15.5458C13.262 15.1699 12.9569 14.8648 12.581 14.8648C12.2051 14.8648 11.9 15.1699 11.9 15.5458C11.9 16.7769 12.8992 17.7761 14.1303 17.7761H18.391C19.6221 17.7761 20.6213 16.7769 20.6213 15.5458C20.6213 15.1699 20.3162 14.8648 19.9403 14.8648C19.5644 14.8648 19.2593 15.1699 19.2593 15.5458Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.81 14.889C18.1307 14.889 18.391 14.6287 18.391 14.308V13.5333C18.391 12.785 17.7852 12.1777 17.0354 12.1777H15.486C14.7362 12.1777 14.1304 12.785 14.1304 13.5333V14.308C14.1304 14.6287 14.3907 14.889 14.7114 14.889H17.81ZM17.229 13.8727H15.2924V13.5333C15.2924 13.4265 15.3792 13.3397 15.486 13.3397H17.0354C17.1422 13.3397 17.229 13.4265 17.229 13.5333V13.8727Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M10.78 14.0664C8.90316 14.098 5.33487 14.7346 3.56036 18.5573C3.34841 19.0142 3.38479 19.737 4.73027 19.776C6.07575 19.815 8.606 19.7923 10.166 19.776"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="11.5698"
                    cy="7.90674"
                    r="3.75986"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12450_78578">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div>
              <h5 className="mb-0 text-gray-900 text-base font-semibold">
                Connect with {personName.map((item) => item?.label).join(",")}
              </h5>
              <p>
                Ensure a successful connection with the client by completing
                these steps
              </p>
            </div>
          </div>
          <div className="pl-4 pr-4">
            <div className="mb-5 bg-gray-50 rounded-xl border border-gray-200 p-5 rounded-xl ">
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Payment successful and invites sent to Workers!
              </h3>
              <p className="mb-4 text-gray-700">
                Thank you for your payment. A confirmation of this transaction
                has been sent to your email.
              </p>
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Invoice number{" "}
              </h3>
              <p className="mb-4 text-gray-700">
                <p>{invoiceData?.xero_invoice_number}</p>
              </p>
              <button
                className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                onClick={downloadInvoice}
              >
                Download invoice{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                    stroke="#5786CC"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="flex dailog-footer ">
            <BtnPrimary
              onClick={() => onCloseInvoice()}
              className="ml-1.5 w-auto	px-4 my-auto	ml-auto	mr-0"
            >
              Okay
            </BtnPrimary>
          </div>
        </Dialog>
      </div>
    </div>
  );
};
export default PaymentMethod;
